import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/app/packages/marginly-app/src/app/bootstrap/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/app/packages/marginly-app/src/components/common/wrapper.styled.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/ui/chain-placeholder/index.tsx");
